import { render } from "./MatchView.vue?vue&type=template&id=0ef035bd&scoped=true"
import script from "./MatchView.vue?vue&type=script&lang=js"
export * from "./MatchView.vue?vue&type=script&lang=js"

import "./MatchView.vue?vue&type=style&index=0&id=0ef035bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef035bd"]])

export default __exports__